import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import {
	FooterContainer,
	Column,
	ColumnTitle,
	StyledLink,
	FooterFooter,
	Copyright,
	BackToTop,
} from './footerStyles';
// Holiday logo change revert in 2023
// import Logo from 'core/icons/Logo';
import { default as Logo } from 'core/icons/Holiday2022Logo';
import { svgMap } from 'core/utils/slugMaps';
import { getColor } from 'core/utils/Styles';
import SignupWidget from 'core/components/SignupWidget/SignupWidget';
import ForethoughtButton from 'core/components/Forethought/ForethoughtButton';


class Footer extends PureComponent {
	state = {
		bottomEnabled: true,
	}

	toggleBottomEnabled = bottomEnabled => {
		this.setState({ bottomEnabled });
	}

	smoothScroll = (e) => {
		e.preventDefault();
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}


	render () {
		const { renderEmail, footerItems, signupWidget  } = this.props;
		const dt = new Date(Date.now());
		const year = dt.getFullYear();

		return (
			<Fragment>
				<BackToTop onClick={this.smoothScroll} href={"#"}>Back To Top</BackToTop>
				{ renderEmail && <SignupWidget {...signupWidget} /> }
				<FooterContainer>
					{footerItems.map((column, colIdx) => (
						<FooterColumn {...column} key={colIdx} />
					))}
				</FooterContainer>
				<FooterFooter>
					<Logo />
					<Copyright>
						&copy; {year} Cratejoy. All Rights Reserved.
					</Copyright>
				</FooterFooter>
			</Fragment>

		);
	}

	static propTypes = {
		renderEmail: PropTypes.bool,
		signupWidget: PropTypes.object,
		footerItems: PropTypes.array,
	}
}

class FooterColumn extends PureComponent {
	render () {
		const { title, items, openNewWindow } = this.props;

		return (
			<Column>
				<ColumnTitle>{title}</ColumnTitle>
				{items.map((link, linkIdx) => (
					<FooterLink {...link} key={`link-${linkIdx}`} target={openNewWindow ? "_blank" : null} />
				))}
			</Column>
		);
	}

	static propTypes = {
		title: PropTypes.string,
		items: PropTypes.array,
		openNewWindow: PropTypes.bool,
	}
}

class FooterLink extends PureComponent {
	state = {
		isHelpLink: false,
	}

	componentDidMount = () => {
		// we will display "Help" as a link until the 
		// component is mounted and then we will change
		// to a button that will execute the Forethought widget
		// that way the link works on slow mobile devices 
		// while the widget loads
		if (this.props.copy.toLowerCase() === 'help') {
			this.setState({ isHelpLink: true });
		}
	}

	render () {
		const { url, copy, icon, openNewWindow } = this.props;
		const { isHelpLink } = this.state;
		const Icon = icon ? svgMap[icon] : null;

		return (
			isHelpLink
				? <ForethoughtButton label="Help" type="footer-button" />
				: <StyledLink href={url} target={openNewWindow ? "_blank" : null}>
					{ Icon && <Icon width={16} height={16} fill={getColor('gray')} /> }
					{copy}
				</StyledLink>
		);
	}

	static propTypes = {
		url: PropTypes.string,
		copy: PropTypes.string,
		icon: PropTypes.string,
		openNewWindow: PropTypes.bool,
	}

	static defaultProps = {
		copy: "",
		url: "",
		icon: "",
		openNewWindow: false
	};
}

export default hot(module)(Footer);
